export default __webpack_public_path__ + "static/media/F1_4.5fa1acee.png";